// One typed edit, one save. A cell that saves on Enter and on leaving it (blur) would save twice
// when Enter's save moves the focus (a dialog, the list read again): the second with the record's
// old version, a 409. The gate opens when the person types, and the first commit closes it; Esc
// closes it with nothing saved. A commit that was refused (a check failed) opens it again.

export interface EditGate {
  /** The person typed: the next commit saves. */
  edit(): void;
  /** Whether this commit saves; the gate is closed after it. */
  take(): boolean;
  /** Esc: nothing to save. */
  cancel(): void;
}

export function editGate(): EditGate {
  let open = false;
  return {
    edit: () => void (open = true),
    take: () => {
      const was = open;
      open = false;
      return was;
    },
    cancel: () => void (open = false),
  };
}
